window.addEventListener("DOMContentLoaded", (event) => {
    // const logoUrl = 'https://isolution.be/files/uploads/2025/10/theme-isolution-logo-white.svg';
    //
    // const navWrapper = document.querySelector('.gform-conversational__form-nav-wrapper');
    // if (navWrapper) {
    //     const logoImage = document.createElement('img');
    //
    //     logoImage.src = logoUrl;
    //     logoImage.alt = 'Logo Isolution'; // Important pour l'accessibilité
    //     logoImage.className = 'pdw-form-logo';
    //     logoImage.style.height = '35px';
    //     logoImage.style.width = 'auto'; // Garde les proportions
    //     logoImage.style.marginRight = 'auto'; // Pour le pousser à gauche
    //
    //     navWrapper.prepend(logoImage);
    //
    // } else {
    //     console.error("L'élément .gform-conversational__form-nav-wrapper n'a pas été trouvé.");
    // }
});